import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import SelectEvent from '../controls/SelectEvent.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';
import '../../../resources/css/relatorio.css';

class CompradoresPorProduto extends React.Component {

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.RELATORIO_COMPRADORES_POR_PRODUTO)
            return null;

        const token = this.props.token;
        const eventId = this.props.participants.selectedEvent ? this.props.participants.selectedEvent.id : null;

        const products = this.props.sorteio.products
            .map(p => ({name: p.name, id: p.id}));
        products.unshift({name: 'Selecione', id: null});

        const datatablesColumns = [
            { data: "id", title: "Número do pedido", render: $.datatable.renders.text() },
            { data: "cpf", title: "CPF", render: $.datatable.renders.text() },
            { data: "nome", title: "Comprador", render: $.datatable.renders.text() },
        ];

        let productId = null;

        let urlBase = '/api/reports/compradores/por_produto';
        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: `${urlBase}?${$.param(_.pickBy({eventId}, _.identity))}`,
        });

        function updateUrl(dt) {
            const query = {
                '_': (new Date()).getTime(),
                productId,
                eventId,
            };

            callbacks._selectUrl = `${urlBase}?${$.param(_.pickBy(query, _.identity))}`;
            dt.ajax.reload();
        }

        const buttons = [
            {
                extend: 'csv',
                text: 'download',
                fieldSeparator: ';',
                filename: 'CompradoresPorProduto',
            },
            {
                extend: 'collection',
                text: 'Produto: ' + products[0].name,
                className: 'produtos-button-group',
                buttons: _.map(products, function (product) {
                    return {
                        text: product.name,
                        action: function (e, dt) {
                            productId = product.id;
                            $('.' + domClassName + ' .produtos-button-group').text('Produto: ' + product.name);
                            updateUrl(dt);
                        }
                    }
                }),
                autoClose: true,
            },
        ];

        const domClassName = 'report-compradores-por-produto';

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Relatório de Compradores por produto</h2>
                    </div>
                </div>

                <SelectEvent {...this.props}/>

                <Datatable DomClassName={domClassName}
                           title={null}
                           subTitle={null}
                           responsive={true}
                           pageLength={100}
                           buttons={buttons}
                           editorCreateVisible={false}
                           editorEditVisible={false}
                           editorRemoveVisible={false}
                           datatablesColumns={datatablesColumns}
                           datatablesSelect={callbacks.select.bind(callbacks)}
                />
            </div>
        );
    }
}

export default CompradoresPorProduto;



// WEBPACK FOOTER //
// src/views/pages/RelatorioCompradoresPorProduto.jsx